export const isProduction = window.location.hostname === 'www.coworker.com' || window.location.hostname === 'www.staging.coworker.com';

const hostname = window.location.hostname;
const isValid = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/.test(hostname);
export const baseURL = `https://${isValid ? hostname : 'www.coworker.com'}/`;